import { create } from 'zustand';

export type NegotiationStatus = 'ONGOING' | 'CLOSED';

interface NegotiationStatusState {
  negotiationStatus: NegotiationStatus | null;
  setNegotiationStatus: (status: NegotiationStatus | null) => void;
  clearNegotiationStatus: () => void;
}

export const useNegotiationStatusStore = create<NegotiationStatusState>(set => ({
  negotiationStatus: null,
  setNegotiationStatus: status => set({ negotiationStatus: status }),
  clearNegotiationStatus: () => set({ negotiationStatus: null }),
}));

export const selectorNegotiationStatus = (state: NegotiationStatusState) => state.negotiationStatus;

